export enum TrovataMessageType {
	SESSION_ID = 'trovata-session-id',
	ACTION = 'trovata-action',
}

export enum MessageAction {
	CREATING_CONNECTION = 'creating-new-connection', // connection is loading
	CONNECTION_FAILED = 'connection-failed', // connection creation failed
	CONNECTION_CREATED = 'new-connection-created', // user successfully created a connection
	ADDITIONAL_CONNECTION_REQUESTED = 'additional-connection-requested', // user clicked "connect another bank" on the success screen
	EXITED_CONNECTION_CREATION = 'exited-connection-creation', // leaving creation flow
	ABANDONED_CONNECTION_FORM = 'abandoned-connection-form', // user backed out of the connection details form
	SET_IFRAME_SQUARE = 'set-iframe-square', // request host to remove iframe border radius (e.g. Wells Fargo branding)
}

export interface SessionIDPayload {
	sessionId: string;
	partnerId?: string;
}

export interface ActionPayload {
	action: string;
	data?: unknown;
}

export type TrovataMessagePayload = SessionIDPayload | ActionPayload | undefined;

export interface SessionIDMessage extends TrovataMessage {
	type: TrovataMessageType.SESSION_ID;
	sessionId: string;
	partnerId?: string;
	payload?: SessionIDPayload;
}

export interface ActionMessage extends TrovataMessage {
	type: TrovataMessageType.ACTION;
	payload: ActionPayload;
}

export interface TrovataMessage {
	type: TrovataMessageType;
	payload?: TrovataMessagePayload;
}
